import { Injectable, signal } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { toast } from '@spartan-ng/brain/sonner'

@Injectable({
    providedIn: 'root',
})
export class ForgotPasswordFormService {
    readonly form: FormGroup
    readonly isSubmitting = signal(false)
    readonly submitted = signal(false)

    constructor(private fb: FormBuilder) {
        this.form = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
        })
    }

    get email() {
        return this.form.get('email')
    }

    submit() {
        if (this.form.invalid) {
            this.form.markAllAsTouched()
            return
        }
        this.isSubmitting.set(true)
        setTimeout(() => {
            this.isSubmitting.set(false)
            this.submitted.set(true)
            toast.success(`Password reset requested for ${this.email?.value}`)
        }, 1000)
    }
}
